<dx-toolbar>
  <dxi-item location="before">
    <span class="toolbar-header">{{ titleText }}</span>
  </dxi-item>

  <dxi-item *ngIf="panelItems" location="before">
    <dx-tabs
      [width]="(screen.xSmallScreenChanged | async) ? 150 : 'auto'"
      [showNavButtons]="false"
      [scrollByContent]="true"
      [selectedItemKeys]="selectedItems"
      keyExpr="key"
      [items]="panelItems"
      (onItemClick)="selectionChange($event)"
    ></dx-tabs>
  </dxi-item>

  <dxi-item location="after" locateInMenu="auto">
    <dx-button
      class="add-card"
      icon="plus"
      text="Kart Ekle"
      type="default"
      stylingMode="contained"
    ></dx-button>
  </dxi-item>

  <dxi-item
    location="after"
    locateInMenu="auto"
    widget="dxButton"
    showText="inMenu"
    [options]="{
      text: 'Yenile',
      icon: 'refresh',
      stylingMode: 'text'
    }"
  ></dxi-item>

  <dxi-item location="after" locateInMenu="auto">
    <div class="separator"></div>
  </dxi-item>

  <dxi-item
    location="after"
    locateInMenu="auto"
    widget="dxButton"
    showText="Menü"
    [options]="{
      icon: 'export',
      text: 'Export',
      stylingMode: 'text'
    }"
  ></dxi-item>
</dx-toolbar>
